export enum VendorFileType {
  CSV = "CSV",
  PDF = "PDF"
}
